import { Box, Center, Flex, Icon, Text } from '@chakra-ui/core';
import React from 'react';
import { MdInfoOutline } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

const ValidationRuleBox: React.FC<{
  message: React.ReactNode;
}> = ({ message }) => {
  const { t } = useTranslation('questionnaireTemplate');
  return (
    <Box mt={4} border="1px solid" borderColor="brand_200" bg="#EEF4FF" borderRadius="8px" px={5} py={4}>
      <Flex align="flex-start">
        <Center mr={3} minW="24px" minH="24px">
          <Icon as={MdInfoOutline} color="#1F3CBA" boxSize={4} />
        </Center>

        <Box>
          <Text fontSize="14px" fontWeight="600" color="#2F6FED" mb={2}>
            {t('formBuilder.canvas.element.validationRules.title')}
          </Text>
          <Text data-testid="validation-rule-message" fontSize="14px" color="#2D3748" lineHeight="1.6" wordBreak="break-word">
            {message}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default ValidationRuleBox;
